module.exports = "<p-tree [style]=\"{'width':'250px','height':'500px'}\" #tree [value]=\"user_group\" selectionMode=\"checkbox\" [(selection)]=\"selectedGroups\"  (onNodeSelect)=\"onNodeSelects($event)\" (onNodeUnselect)=\"onNodeUnSelect($event)\" ></p-tree>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/user_checktree.component.html
// module id = ../../../../../src/app/component/user_checktree.component.html
// module chunks = 1